import { useEffect, useState } from "react";
import useQuerySearch from "./useQuerySearch";

export interface IWithQuerySelector {
    getSearch?: (query: string) => Promise<any>;
    timeout?: number;
}

export interface ViewQuerySelectorProps {
    result: any;
    isLoading: boolean;
    errorMessage: string | null;
    onClickItem: (item: any) => void;
    setValueQuery: (value: string) => void;
    valueQuery?: string | null;
}

export default function useQuerySelector<T>(config: IWithQuerySelector) {

    const [result, setResult] = useState<T | null>(null);
    const [error, setError] = useState< any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);


    const sendQuery = (query: string | null) => {
       
          if (config.getSearch){
            setIsLoading(true) 
            setError(null);
            config.getSearch(query || "")
              .then((res) => {
                setResult(res);
                setIsLoading(false);
              })
              .catch((e) => {
                setError(e);
                setIsLoading(false);
              });
        
      }
      };
      const { setQuery, valueQuery } =useQuerySearch({
        timeout: config.timeout,
        setIsLoading: setIsLoading,
        sendQuery: sendQuery,
       
    })

   

      useEffect(() => {
        sendQuery("");
      }, []) // eslint-disable-line


      return {
        resultFound : result,
        isLoading,
     
        error,
      
        setValueQuery: setQuery,
        valueQuery
      }



  
}
